import ReferencesControleController from './references.controle.controller';

export default {
    template: require('./references.controle.tpl.html'),
    controller: ReferencesControleController
};
